module.exports = {
  TheNotYourCustomerSelect: 'หน่วยงานที่มอบหมายนี้ไม่ใช่ลูกค้าของคุณ โปรดเลือกใหม่!',
  YourAuthorityIsInsufficient: 'คุณไม่มีสิทธิ์เพียงพอ',
  SailingSchedule2: 'ตารางเรือ 2:',
  Voyage: 'เส้นทางเดินเรือ:',
  OverweightDescription: 'คำอธิบายน้ำหนักเกิน:',
  LowestPrice: 'ราคาต่ำสุด',
  SailingSchedule: 'ตารางเรือ:',
  FullContainerFreightSharingDetails: 'รายละเอียดการแบ่งปันอัตราค่าขนส่งแบบเต็มตู้',
  FullContainerFCLFreight: 'อัตราค่าขนส่งแบบเต็มตู้ (FCL)',
  LessContainerLoadLCLFreight: 'อัตราค่าขนส่งแบบรวมตู้ (LCL)',
  AirCargoAIRFreight: 'อัตราค่าขนส่งทางอากาศ (AIR)',
  All: 'ทั้งหมด',
  Code: 'รหัส',
  ChineseName: 'ชื่อภาษาจีน',
  EnglishName: 'ชื่อภาษาอังกฤษ',
  Country: 'ประเทศ',
  Region: 'ภูมิภาค',
  AirFreightSurchargeDetails: 'รายละเอียดค่าบริการเพิ่มเติมทางอากาศ',
  Empty: 'ว่าง',
  LCLDestinationPortChargesDetails: 'รายละเอียดค่าธรรมเนียมท่าเรือปลายทางแบบรวมตู้',
  AirCargoRateDetails: 'รายละเอียดอัตราค่าขนส่งทางอากาศ',
  SecondTransit: 'การขนส่งต่อที่สอง',
  SecondLegAircraftType: 'ประเภทเครื่องบินเที่ยวที่สอง',
  SecondLegFlightSchedule: 'เวลาการบินเที่ยวที่สอง',
  SecondScheduleCannotBeEmpty: 'เวลาการบินเที่ยวที่สองไม่สามารถเว้นว่างได้',
  ProgramSettings: 'การตั้งค่าแผน',
  FullContainerFreightDetails: 'รายละเอียดอัตราค่าขนส่งแบบเต็มตู้',
  EuropeAndAmericaLinesDedicated: 'สำหรับเส้นทางยุโรป-อเมริกาโดยเฉพาะ',
  EmailCannotBeEmpty: 'อีเมลไม่สามารถเว้นว่างได้',
  EmailFormatError: 'รูปแบบอีเมลไม่ถูกต้อง',
  DestinationAreaError: 'ภูมิภาคปลายทางไม่ถูกต้อง!',
  ContinueImporting: ',ต้องการนำเข้าต่อไปหรือไม่?',
  FullContainerAddonFreightDetails: 'รายละเอียดอัตราค่าขนส่ง Addon แบบเต็มตู้',
  FullContainerAdditionalInformationDetails: 'รายละเอียดข้อมูลเพิ่มเติมแบบเต็มตู้',
  LCLFreightDetails: 'รายละเอียดอัตราค่าขนส่งแบบรวมตู้',
  CostPrice: 'ราคาต้นทุน',
  PeerPrice: 'ราคาสำหรับบริษัทขนส่ง',
  DirectCustomerPrice: 'ราคาสำหรับลูกค้าโดยตรง',
  MarketPrice: 'ราคาตลาด',
  LCLAddonFreightDetails: 'รายละเอียดอัตราค่าขนส่ง Addon แบบรวมตู้',
  YourPermissionIsNotEnough: 'คุณไม่มีสิทธิ์เพียงพอ',
  SailingTime: 'เส้นทางเดินเรือ:',
  FCL: 'เต็มตู้',
  LCL: 'รวมตู้',
  FreightNumber: 'หมายเลขอัตราค่าขนส่ง:',
  CabinStatus: 'สถานะพื้นที่จัดเก็บ:',
  OurDumpingOfContainersOK: 'บริษัทของเราไม่สามารถรับประกันว่าจะไม่มีการยกเลิกตู้สินค้าแม้ในกรณีที่การจัดเตรียมเรียบร้อยแล้ว',
  NoteAdditionalChargesWithBackground: 'หมายเหตุ: ราคา ALL IN รวมค่าบริการเพิ่มเติมที่แสดงด้วยพื้นหลังสีเทาแล้ว',
  Booking: 'จองพื้นที่จัดเก็บ',
  ThisFareHasExpired: 'อัตราค่าขนส่งนี้หมดอายุแล้ว!',
  NoFreightThatMeetsParty: 'ไม่พบวันที่ออกเรือที่ตรงตามกำหนดการเดินเรือภายในระยะเวลาที่อัตราค่าโดยสารมีผล กรุณาติดต่อผู้จัดวางเพื่อยืนยัน!',
  Subscribe: 'สมัครสมาชิก',
  SetEmailToReceiveInformation: 'ตั้งค่าอีเมลที่คุณต้องการรับข้อมูลการสมัครสมาชิก',
  TheEmailCannotBeEmpty: 'อีเมลห้ามเว้นว่าง',
  SetCompanyToReceiveInformation: 'ตั้งค่าสาขาบริษัทที่คุณต้องการรับข้อมูลการสมัครสมาชิก',
  SetYouWantToTo: 'ตั้งค่าคู่ค้าที่คุณต้องการสมัครสมาชิก',
  AdvancedSettings: 'การตั้งค่าขั้นสูง',
  SubscriptionType: 'ประเภทการสมัครสมาชิก',
  PlaceOfDeparture: 'สถานที่ออกเดินทาง',
  DischargePort: 'สถานที่ขนถ่ายสินค้า',
  Airline: 'สายการบิน',
  ShippingCompany: 'บริษัทเรือ',
  Confirm: 'ตกลง',
  Reset: 'รีเซ็ต',
  Refresh: 'รีเฟรช',
  Cancel: 'ยกเลิก',
  PleaseYouWillReceiveUpdated: 'กรุณาสมัครสมาชิกข้อมูลที่คุณสนใจ เมื่ออัตราค่าโดยสารอัปเดต คุณจะได้รับอีเมลแจ้งเตือน',
  Add: 'เพิ่มใหม่',
  Edit: 'แก้ไข',
  Delete: 'ลบ',
  GoBack: 'กลับ',
  Save: 'บันทึก',
  SubCompany: 'สาขาบริษัท',
  DeparturePort: 'ท่าเรือออกเดินทาง',
  DepartureCountry: 'ประเทศต้นทาง',
  DepartureArea: 'ภูมิภาคต้นทาง',
  DestinationPort: 'ท่าเรือปลายทาง',
  DestinationCountryRegion: 'ประเทศปลายทาง (ภูมิภาค)',
  DestinationArea: 'ภูมิภาคปลายทาง',
  FCLWeightLimitInformationDetails: 'รายละเอียดข้อมูลน้ำหนักสูงสุดของตู้คอนเทนเนอร์',
  PleaseTheEntrustedContainerVolume: 'กรุณากรอกจำนวนตู้คอนเทนเนอร์ที่มอบหมาย!',
  TheBelongToYourSelect: 'หน่วยงานที่มอบหมายนี้ไม่ใช่ลูกค้าของคุณ กรุณาเลือกใหม่!',
  ExternalUser: 'ผู้ใช้ภายนอก',
  FCLSailingScheduleManagement: 'การจัดการตารางเดินเรือตู้คอนเทนเนอร์',
  ConfigSurchargeFcl: 'กำหนดค่าธรรมเนียมเพิ่มเติม',
  FCLAdditionalFeeMaintenance: 'บำรุงรักษาค่าธรรมเนียมเพิ่มเติมตู้คอนเทนเนอร์',
  HsCode: 'รหัส HS',
  UnNo: 'หมายเลข UN'
}
